export default __webpack_public_path__ + "static/media/DSC_0520.6d170400.jpg";